import React from 'react';
import { motion } from 'framer-motion';

const PurchasePlatforms = () => {
  const platforms = [
    { name: 'APPLE BOOKS', url: 'https://books.apple.com/us/book/ned-and-nancy-the-first-clue/id6474623788' },
    { name: 'AMAZON', url: 'https://a.co/d/ciDjnhM' },
    { name: 'KOBO', url: 'https://www.kobo.com/us/en/ebook/ned-and-nancy-the-first-clue' },
    { name: 'BARNES & NOBLE', url: 'https://www.barnesandnoble.com/w/ned-and-nancy-carter-case/1144511802?ean=9781951434212' }
  ];

  return (
    <div className="py-20 bg-white relative overflow-hidden">
      {/* Background Animation */}
      <motion.div 
        className="absolute inset-0 opacity-5"
        animate={{ 
          backgroundPosition: ['0% 0%', '100% 100%'],
        }}
        transition={{ 
          duration: 20,
          repeat: Infinity,
          repeatType: 'reverse'
        }}
        style={{
          backgroundImage: 'radial-gradient(circle at center, #4169E1 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-center mb-16"
          style={{ color: '#4169E1' }}
        >
          Available on These Platforms
          <span className="text-slate-400"> (and more!)</span>
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {platforms.map((platform, index) => (
            <motion.div
              key={platform.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex justify-center"
            >
              <motion.a
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="group relative block w-full sm:w-64"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-400 rounded-lg transform transition-transform group-hover:scale-105 opacity-0 group-hover:opacity-100 blur" />
                <div className="relative bg-slate-900 text-white py-4 px-6 rounded-lg text-center transform transition-transform shadow-lg hover:shadow-2xl h-14 flex items-center justify-center">
                  <span className="block text-lg font-bold tracking-wide whitespace-nowrap">
                    BUY ON {platform.name}
                  </span>
                  <motion.div
                    className="absolute bottom-0 left-0 right-0 h-1 bg-blue-400"
                    initial={{ width: 0 }}
                    whileHover={{ width: '100%' }}
                    transition={{ duration: 0.3 }}
                  />
                </div>
              </motion.a>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PurchasePlatforms;